import { TemplateManagementService } from '../services/templateManagementService';
import { TOAST_NOTIFICATION_MESSAGES } from './toastNotificationMessages';
import { TOAST_NOTIFICATION_TYPES } from './toastNotificationTypes';

// NOTE: TOAST_NOTIFICATION_TEMPLATES tests only cover notification data logic.
// Future tests should check that receiving a notification actually shows a toast in the UI.
export const TOAST_NOTIFICATION_TEMPLATES = {
  [TOAST_NOTIFICATION_TYPES.EVENT_COMMENT_ADDED]:
    TemplateManagementService.createCommentEventTemplate(
      TOAST_NOTIFICATION_MESSAGES[TOAST_NOTIFICATION_TYPES.EVENT_COMMENT_ADDED]
    ),
  [TOAST_NOTIFICATION_TYPES.EVENT_COMMENT_EDITED]:
    TemplateManagementService.createCommentEventTemplate(
      TOAST_NOTIFICATION_MESSAGES[TOAST_NOTIFICATION_TYPES.EVENT_COMMENT_EDITED]
    ),
  [TOAST_NOTIFICATION_TYPES.EVENT_MOVED_TO_READY_TO_DELIVER]:
    TemplateManagementService.createBasicEventTemplate(
      TOAST_NOTIFICATION_MESSAGES[TOAST_NOTIFICATION_TYPES.EVENT_MOVED_TO_READY_TO_DELIVER]
    ),
  [TOAST_NOTIFICATION_TYPES.EVENT_CONFIRM_ASSIGNMENT]:
    TemplateManagementService.createCommentEventTemplate(
      TOAST_NOTIFICATION_MESSAGES[TOAST_NOTIFICATION_TYPES.EVENT_CONFIRM_ASSIGNMENT]
    ),
  [TOAST_NOTIFICATION_TYPES.EVENT_DECLINE_ASSIGNMENT]:
    TemplateManagementService.createCommentEventTemplate(
      TOAST_NOTIFICATION_MESSAGES[TOAST_NOTIFICATION_TYPES.EVENT_DECLINE_ASSIGNMENT]
    ),
  [TOAST_NOTIFICATION_TYPES.EVENT_SUBMITTED]: TemplateManagementService.createBasicEventTemplate(
    TOAST_NOTIFICATION_MESSAGES[TOAST_NOTIFICATION_TYPES.EVENT_SUBMITTED]
  ),
  [TOAST_NOTIFICATION_TYPES.EVENT_ATL_OBSERVER_ASSIGNED]:
    TemplateManagementService.createBasicEventTemplate(
      TOAST_NOTIFICATION_MESSAGES[TOAST_NOTIFICATION_TYPES.EVENT_ATL_OBSERVER_ASSIGNED]
    ),
  [TOAST_NOTIFICATION_TYPES.EVENT_ATL_OBSERVER_UNASSIGNED]:
    TemplateManagementService.createMessageTemplate(
      TOAST_NOTIFICATION_MESSAGES[TOAST_NOTIFICATION_TYPES.EVENT_ATL_OBSERVER_UNASSIGNED]
    ),
  [TOAST_NOTIFICATION_TYPES.EVENT_ATL_OBSERVABLE_UNASSIGNED]:
    TemplateManagementService.createBasicEventTemplate(
      TOAST_NOTIFICATION_MESSAGES[TOAST_NOTIFICATION_TYPES.EVENT_ATL_OBSERVABLE_UNASSIGNED]
    ),
  [TOAST_NOTIFICATION_TYPES.INVALID_FILE]: TemplateManagementService.createMessageTemplate(
    TOAST_NOTIFICATION_MESSAGES[TOAST_NOTIFICATION_TYPES.INVALID_FILE]
  ),
  [TOAST_NOTIFICATION_TYPES.EVENT_ATM_OBSERVER_ASSIGNED]:
    TemplateManagementService.createBasicEventTemplate(
      TOAST_NOTIFICATION_MESSAGES[TOAST_NOTIFICATION_TYPES.EVENT_ATM_OBSERVER_ASSIGNED]
    ),

  [TOAST_NOTIFICATION_TYPES.USER_ASSIGNED_TO_FUTURE_EVENT]:
    TemplateManagementService.createBasicEventTemplate(
      TOAST_NOTIFICATION_MESSAGES[TOAST_NOTIFICATION_TYPES.USER_ASSIGNED_TO_FUTURE_EVENT]
    ),
  [TOAST_NOTIFICATION_TYPES.USER_INVITED_TO_FUTURE_EVENT]:
    TemplateManagementService.createBasicEventTemplate(
      TOAST_NOTIFICATION_MESSAGES[TOAST_NOTIFICATION_TYPES.USER_INVITED_TO_FUTURE_EVENT]
    ),

  [TOAST_NOTIFICATION_TYPES.ORG_UNIT_DEACTIVATED_AND_EVENT_GOT_REMOVED]:
    TemplateManagementService.createMessageTemplate(
      TOAST_NOTIFICATION_MESSAGES[
        TOAST_NOTIFICATION_TYPES.ORG_UNIT_DEACTIVATED_AND_EVENT_GOT_REMOVED
      ]
    ),
  [TOAST_NOTIFICATION_TYPES.ORG_UNIT_DEACTIVATED_AND_REMOVED_FROM_MULTI_SITE_EVENT]:
    TemplateManagementService.createMessageTemplate(
      TOAST_NOTIFICATION_MESSAGES[
        TOAST_NOTIFICATION_TYPES.ORG_UNIT_DEACTIVATED_AND_REMOVED_FROM_MULTI_SITE_EVENT
      ]
    ),
  [TOAST_NOTIFICATION_TYPES.OBSERVATION_REPORT_SUBMITTED]:
    TemplateManagementService.createRedirectMessageTemplate(
      TOAST_NOTIFICATION_MESSAGES[TOAST_NOTIFICATION_TYPES.OBSERVATION_REPORT_SUBMITTED],
      'observation-report/{observationReportId}'
    )
};
